import { createReducer, on } from '@ngrx/store';
import { FaqCategory } from '../../models';
import * as pageActions from '../actions/faq-categories.action';
import * as utility from '../../../utility';
import { HttpErrorResponse } from '@angular/common/http';

export interface FaqCategoriesState {
  entities: { [slug: string]: FaqCategory };
  loaded: boolean;
  loading: boolean;
  error?: HttpErrorResponse | any;
}

export const initialState: FaqCategoriesState = {
  entities: {},
  loaded: false,
  loading: false,
};

export const faqCategoriesReducer = createReducer(
  initialState,
  on(pageActions.LoadFaqCategories, (state: FaqCategoriesState) => {
    return {
      ...state,
      loading: true,
      error: null,
    };
  }),
  on(pageActions.LoadFaqCategoriesSuccess, (state: FaqCategoriesState, { categories }) => {
    const entities = utility.ToEntities(categories, 'name', state.entities);
    return {
      ...state,
      entities,
      loading: false,
      loaded: true,
      error: null,
    };
  }),
  on(pageActions.LoadFaqCategoriesFail, (state: FaqCategoriesState, { error }) => {
    return {
      ...state,
      loading: false,
      loaded: false,
      error,
    };
  })
);

export const getFaqCategoriesEntities = (state: FaqCategoriesState) => state.entities;
export const getFaqCategoriesLoading = (state: FaqCategoriesState) => state.loading;
export const getFaqCategoriesLoaded = (state: FaqCategoriesState) => state.loaded;
export const getFaqCategoriesError = (state: FaqCategoriesState) => state.error;
